import React, {Fragment} from "react";
import {connect} from "react-redux";
import {Redirect, withRouter} from "react-router-dom";

import {adminLogout} from "../../redux/actions";

import {Header} from "./Header";

export const authorised = (Component) =>
  withRouter(connect(
    ({loggedIn}) => ({loggedIn}),
    (dispatch) => ({dispatch})
  )(
    (props) =>
      props.loggedIn ? (
        <Fragment>
          <Header />
          <Component {...props} />
          <button onClick={() => props.dispatch(adminLogout())}>Logout</button>
        </Fragment>
      ) : (
        <Redirect to={{
          pathname: "/login",
          state: {referrer: props.location.pathname}
        }}/>
      )
  ));


// WEBPACK FOOTER //
// ./src/components/layout/authorised.js